import React, { useRef, useState } from "react";
import VideoFile from "../Assests/video.webm";
import { IoPlayCircleOutline } from "react-icons/io5";
import Thumbnail from "../Assests/alratv_img/poster.png";

const VideoSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  const handleEnded = () => {
    videoRef.current.currentTime = 0;
    videoRef.current.load();
    setIsPlaying(false);
  };

  return (
    <div className="md:mx-10 HCP">
      <div className="HCP relative w-full mx-auto max-w-[1365px] aspect-video md:rounded-[24px] overflow-hidden md:mt-[44px]">
        <video
          ref={videoRef}
          src={VideoFile}
          poster={Thumbnail}
          className="w-full h-full object-cover hover:cursor-pointer"
          muted
          playsInline
          controls={isPlaying}
          onEnded={handleEnded}
        />

        {!isPlaying && (
          <button
            onClick={handlePlay}
            className="HCP absolute inset-0 flex flex-col items-center justify-center  text-[#FFFFFF]"
          >
            <span
              className="HCP md:text-[48px] leading-[48px] font-semibold text-center text-[30px]"
              style={{ fontFamily: "Manrope" }}
            >
              Watch The Video
            </span>
            <br />
            <IoPlayCircleOutline
              className="text-[72px] leading-[72px] font-light mb-4"
              style={{ fontFamily: "Font Awesome 6 Pro", letterSpacing: "-3%" }}
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default VideoSection;
